export interface ObraIdentificavel {
  codigo: string;
  embarcacao?: { nome?: string | null; acronimo?: string | null } | null;
}

/** As duas formas visíveis da obra: `24 - Austral Abrolhos` (nome) e `24 - ABR` (sigla). */
export interface IdentificacaoObra {
  nome: string;
  sigla: string;
}

/** `2 - PSV`; só o código quando a obra não tem sigla de embarcação. Forma dos tooltips, do filtro e dos chips (ADR 0018). */
export function formatarIdentificacaoObra({ codigo, embarcacao }: ObraIdentificavel): string {
  const sigla = embarcacao?.acronimo?.trim();
  return sigla ? `${codigo} - ${sigla}` : codigo;
}

/**
 * Forma das pílulas e dos rótulos de tela (ADR 0018): `ID - nome da embarcação` e, quando o nome não cabe, `ID - sigla`.
 * Sem nome, a forma do nome é a da sigla; sem os dois, só o código.
 */
export function identificacaoDaObra(obra: ObraIdentificavel): IdentificacaoObra {
  const sigla = formatarIdentificacaoObra(obra);
  const nomeDaEmbarcacao = obra.embarcacao?.nome?.trim();
  return { nome: nomeDaEmbarcacao ? `${obra.codigo} - ${nomeDaEmbarcacao}` : sigla, sigla };
}

/**
 * Texto corrido de modal (ADR 0018): `ID - nome da embarcação`; sem a embarcação no dado (o 409 do servidor, por exemplo),
 * `ID - nome da obra`, o que existir. As pílulas e os rótulos de tela não usam o nome da obra: `identificacaoDaObra`.
 */
export function textoDaObra(obra: ObraIdentificavel & { nome?: string | null }): string {
  if (obra.embarcacao?.nome?.trim()) return identificacaoDaObra(obra).nome;
  return [obra.codigo, obra.nome].filter(Boolean).join(" - ");
}
